import axios from "axios";
import { configUrl } from "config.js";

const dupulicateCodeCheck = async (testId, testCode) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/Tests/isTestCodeExists/${testId}/${testCode}`
    );
    // let data = response.data;
    console.log(response, 'response1')
    return response.data;
};
const dupulicateTextCheck = async (testId, testText) => {
    let response = await axios.get(
        `${configUrl.AssessmentServer}/api/Tests/isTestNameExists/${testId}/${testText}`
    );
    console.log(response, 'response2')
    // let data = response.data;
    return response.data;
};

export default {
    dupulicateCodeCheck: dupulicateCodeCheck,
    dupulicateTextCheck: dupulicateTextCheck,

}